module.exports = __webpack_public_path__ + "img/gradient-6.7b0a62b9.png";